import { AllotmentNodeDTO } from './ProjectDTO';
import { MasterDataEquipment } from './ProjectsDTO';

export type SimulatorInformationDTO = {
  lifespan: string;
  refUnit: 'm²' | 'total';
  area: string;
  style: 'static' | 'dynamic';
};

export type MasterDataEquipmentDTO = {
  name: string;
  type: string;
  materiel: string;
  categorie: string;
  fonction: string;
  lot: string;
  id: number;
  isObsolete: boolean;
  isConfiguredSheetImportAllowed: boolean;
  hasFluid: boolean;
  unit: string;
  ReSousLotId: number;
  isConnectedToUrbanNetwork: boolean;
  referenceType: string[];
  xAxisId: null | number;
  discreteId: number; //or null?
  secondDiscreteId: number; // or null?
  Parent: [];
  AllotmentNodes: AllotmentNodeDTO[];
  Child: [];
  Keywords: [];
};

export type NewEquipmentDTO = {
  AllotmentNodes: AllotmentNodeDTO[];
  fluid:
    | {
        fluidQuantity?: string | null;
        selectedFluid?: number | null;
        isDefaultFluid?: boolean | null;
      }
    | undefined;
  AllotmentNode: AllotmentNodeDTO;
  SheetId: {};
  MasterDataEquipment: {
    name: string;
    type: string;
    materiel: string;
    categorie: string;
    fonction: string;
    lot: string;
    id: number;
    isObsolete: boolean;
    isConfiguredSheetImportAllowed: boolean;
    hasFluid: boolean;
    unit: string;
    ReSousLotId: number;
    isConnectedToUrbanNetwork: boolean;
    referenceType: string[];
    xAxisId: null | number;
    discreteId: number; //or null?
    secondDiscreteId: number; // or null?
    Parent: [];
    AllotementNodes: [];
    Child: [];
    Keywords: [];
  } | null;
  quantity: number | null;
  caracs: [];
};

export type VariantDTO = {
  quantity: number;
  MasterDataEquipmentId: Number;
  id: number;
  UnitId: number;
  lifespan: any[];
  sheet: { name: string; ddv: number };
  EmissionValues: any[];
  MasterDataEquipment: MasterDataEquipment;
  key: number;
  completeName: string;
};

export type QuickSimVariantData = {
  area: string;
  ddv: number;
  id: number;
  name: string;
  refUnit: string;
};

export type SimulatorDTO = {
  isSimulatorFetchData: boolean | undefined;
  loadingInformation: boolean;
  loadingGraph: boolean;
  information: SimulatorInformationDTO;
  graphicChoice: GraphicChoice | undefined;
  isInformationValid: boolean; // TODO TO DELETE:not Used
  parsedProject: {
    parsed: {
      id: number;
      name: string;
      ddv: number;
      Unit: { id: number; name: string; MasterDataUnitId: number };
      ACV: any;
      ProjectSheet: {
        id: number;
        quantity: number;
        SheetId: number;
        Unit: { id: number; name: string; MasterDataUnitId: number };
        acvResult: {
          total: number;
          usage: {};
          base: {};
          totalFluid: number;
        };
      }[];
    }[];
    raw: {
      id: number;
      source: string;
      quantity: number;
      SheetId: number;
      ZoneId: number;
      MasterDataEquipmentId: number;
      UnitId: number;
      Unit: { id: number; name: string };
    }[];
    zones: {
      id: number;
      localZoneId: number;
      name: string;
      area: number;
      type: string;
      ProjectSheet: {
        id: number;
        quantity: number;
        SheetId: number;
        Unit: { id: number; name: string; MasterDataUnitId: number };
        acvResult: {
          total: number;
          usage: {};
          base: {};
          totalFluid: number;
        };
      }[];
      totalAcv: any;
      Ic: any;
    }[];
  } | null;
  currentAllotment: {
    id: number | undefined;
    name: string | undefined;
    AllotmentNodes: {
      id: number;
      name: string;
      level: number;
      AllotmentId: number;
      ParentId: number;
    }[];
  };
  needDatas: {
    area: number;
    children: [];
    color: string;
    id: number;
    label: string;
    name: string;
  }[];
  currentIndicator: {
    id: number | undefined;
    unit: string | undefined;
  };
  fakeCurrentProject: {
    Lots: {}[];
    refUnit: string;
  };
  dataForGraph: {
    dataGraph:
      | {
          id: number;
          ParentId: number;
          key: number;
          label: string;
          name: string;
          total: number;
          quickSimProject1: number;
          quickSimProject2: number;
        }[]
      | null;
    filters:
      | {
          color: string | undefined;
          id: number;
          label: string;
          name: string;
        }[]
      | null;
    keys: string[] | null;
    currentIndicator: { unit: string; id: number } | null;
    dataGraphLine: {
      id: string;
      color: string;
      data: {
        x: number;
        y: number;
      }[];
    }[];
  };
  firstVariant: {
    loadingVariant: boolean;
    addChoice: 'energy' | 'equipment' | undefined;
    variantListDatas: VariantDTO[];
    newEquipment: NewEquipmentDTO;
    selectedRowKeys: number[];
    newEquipmentQuantity: number | null;
    data: QuickSimVariantData | null;
    parsedProject: [] | null;
  };
  secondVariant: {
    loadingVariant: boolean;
    addChoice: 'energy' | 'equipment' | undefined;
    variantListDatas: VariantDTO[];
    newEquipment: NewEquipmentDTO;
    selectedRowKeys: number[];
    newEquipmentQuantity: number | null;
    data: QuickSimVariantData | null;
    parsedProject: [] | null;
  };
  sheetsGraph: any;
  equipmentClicked: {
    id: number;
    MasterDataEquipment: MasterDataEquipmentDTO;
    MasterDataEquipmentId: number;
    quantity: number;
    unit: string;
    name: string;
    key: number;
    completeName: string;
    currentMd: any;
    parsedProjectZones: any;
  } | null;
};

export enum GraphicChoice {
  RADAR = 'radar',
  BAR = 'bar',
  LINE = 'line',
  ACV = 'acv',
}
